import { all, call, getContext, put, takeLatest } from 'redux-saga/effects';
import CustomerApi from '../../../api/customer/CustomerApi';
import { CustomerActionTypes } from '../../../enums/ActionEnums';
import customerActions from '../actions/CustomerActions.creators';
function* getProfile() {
    try {
        const { defaultRequestParams, servicesEndpoint } = yield getContext('aemConfiguration');
        const response = yield call(CustomerApi.getProfile, servicesEndpoint, defaultRequestParams);
        yield put(customerActions.setProfile(response));
    }
    catch (_a) { }
}
function* getDeliveryAddresses() {
    try {
        const { defaultRequestParams, servicesEndpoint } = yield getContext('aemConfiguration');
        const response = yield call(CustomerApi.deliveryAddress, servicesEndpoint, defaultRequestParams);
        yield put(customerActions.setDeliveryAddresses(response));
    }
    catch (_a) { }
}
function* deleteDeliveryAddress(action) {
    try {
        const { defaultRequestParams, servicesEndpoint } = yield getContext('aemConfiguration');
        yield call(CustomerApi.deleteDeliveryAddress, servicesEndpoint, defaultRequestParams, action.payload);
        yield put(customerActions.getDeliveryAddresses());
    }
    catch (_a) { }
}
function* addDeliveryAddress(action) {
    try {
        const { defaultRequestParams, servicesEndpoint } = yield getContext('aemConfiguration');
        yield call(CustomerApi.addDeliveryAddress, servicesEndpoint, defaultRequestParams, action.payload);
    }
    catch (_a) { }
}
export function* getProfileSaga() {
    yield takeLatest(CustomerActionTypes.GET_PROFILE, getProfile);
}
export function* getDeliveryAddressesSaga() {
    yield takeLatest(CustomerActionTypes.GET_DELIVERY_ADDRESSES, getDeliveryAddresses);
}
export function* deleteDeliveryAddressesSaga() {
    yield takeLatest(CustomerActionTypes.DELETE_DELIVERY_ADDRESS, deleteDeliveryAddress);
}
export function* addDeliveryAddressesSaga() {
    yield takeLatest(CustomerActionTypes.ADD_DELIVERY_ADDRESS, addDeliveryAddress);
}
export default function* customerSaga() {
    yield all([getProfileSaga(), getDeliveryAddressesSaga(), deleteDeliveryAddressesSaga(), addDeliveryAddressesSaga()]);
}
